package playground.gradient.ui

import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.snap
import androidx.compose.animation.core.spring
import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.detectHorizontalDragGestures
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.setValue
import androidx.compose.ui.BiasAlignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.TransformOrigin
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.delay
import playground.gradient.ui.components.Slider
import kotlin.math.absoluteValue

@Composable
fun RGBColorPicker(
    color: Color = Color(0xffff0000),
    setColor: (Color) -> Unit,
) {


    Column(
        modifier = Modifier.padding(24.dp),
        verticalArrangement = Arrangement.Center
    ) {

        Slider(
            value = color.red,
            setValue = {
                setColor(
                    color.copy(red = it)
                )
            }
        )
        Text("red = ${(color.red * 255).toInt()}")

        Slider(
            value = color.green,
            setValue = {
                setColor(
                    color.copy(green = it)
                )
            }
        )
        Text("green = ${(color.green * 255).toInt()}")

        Slider(
            value = color.blue,
            setValue = {
                setColor(
                    color.copy(blue = it)
                )
            }
        )
        Text("blue = ${(color.blue * 255).toInt()}")
    }

}